import type { InputHTMLAttributes } from 'vue';

type BinderFactory = (allowDecimal: boolean) => Partial<InputHTMLAttributes>;


const isDigit = (e: KeyboardEvent): boolean => /[0-9]/.test(e.key);

const isDecimalPoint = (e: KeyboardEvent, currentValue: string): boolean => (
    e.key === '.' && !currentValue.includes('.')
);

const CTRL_SHORTCUT_CODES = new Set(['KeyA', 'KeyC', 'KeyV', 'KeyX', 'KeyZ']);

const isCtrlShortcut = (e: KeyboardEvent): boolean => (
    e.ctrlKey && CTRL_SHORTCUT_CODES.has(e.code)
);

const NAVIGATION_CODES = new Set(['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Tab']);

const isNavigationKey = (e: KeyboardEvent): boolean => NAVIGATION_CODES.has(e.code);


const createAllowOnlyIntegers = (allowDecimal: boolean = false) => ({
    onKeydown: (e: KeyboardEvent) => {
        const input = e.target as HTMLInputElement;
        const currentValue = input.value;
        
        if (
            isDigit(e) ||
            (allowDecimal && isDecimalPoint(e, currentValue)) ||
            isCtrlShortcut(e) ||
            isNavigationKey(e)
        ) {
            return;
        }

        e.preventDefault();
    },
    inputmode: 'numeric' as const,
    autocomplete: 'off' as const,
    spellcheck: false as const,
} satisfies Partial<InputHTMLAttributes>);

const allowOnlyIntegers = Object.assign(
    (allowDecimal: boolean = false) => createAllowOnlyIntegers(allowDecimal),
    createAllowOnlyIntegers(false)
) satisfies Partial<InputHTMLAttributes> & BinderFactory;


export {
    allowOnlyIntegers,
}
